<div class="route-one-jacket-modal">
    <div *ngIf="!isLoading" class="closing-x-wrap">
        <mat-icon class="close-icon condenced" alt="Close dialog" (click)="close()">
            close
        </mat-icon>
    </div>
    <h1 mat-dialog-title>Update RouteOne User Information</h1>
    <div mat-dialog-content>
        <ng-container *ngIf="isLoading">
            <div class="loader-wrap">
                <three-dot-loader></three-dot-loader>
            </div>
        </ng-container>
        <div *ngIf="!r1DealerId">
            <ng-container *ngIf="!isLoading && !routeOneResponse">
                <p>
                    To send requests to and from Route One we will need your Route One Dealership information.
                </p>
                <p>
                    An example of a Route One Dealership Id is: A five character value like "AZ0BY".
                </p>
                <p class="r1-info">
                    <span class="label">Route One Dealership Id: </span>
                    {{ r1DealerId || 'Unknown' }}
                </p>
            </ng-container>
        </div>
        <div *ngIf="r1DealerId">
            <ng-container *ngIf="!isLoading && !routeOneResponse">
                <p>
                    To send requests to and from Route One we will need your Route One Dealership information. The current RouteOne Dealership Id is invalid.
                </p>
                <p>
                    Please contact Support to resolve this issue. Email: {{supportEmail}} Phone: {{supportPhone}}
                </p>
                <p class="r1-info">
                    <span class="label">Route One Dealership Id: </span>
                    {{ r1DealerId || 'Unknown' }}
                </p>
            </ng-container>
        </div>
        <ng-container *ngIf="!isLoading && routeOneResponse?.error">
            <p>
                {{ routeOneResponse.message }}
            </p>
        </ng-container>
    </div>
    <div class="settings-group">
        <div class="section-wrapper">
                <div class="align-home">
                    <form [formGroup]="userUpdateGroup" (ngSubmit)="updateR1UserInfo()">
                        <div *ngIf="r1DealerId">
                            <mat-form-field  required class="col">
                                <mat-label>Route One Dealership</mat-label>
                                <input [disabled]="true" [readonly]="true" type="text" matInput formControlName="dealershipId" [ngModel]="r1DealerId" maxlength="5" />
                            </mat-form-field>
                        </div>
                        <div *ngIf="!r1DealerId">
                            <mat-form-field required class="col">
                                <mat-label>Route One Dealership</mat-label>
                                <input type="text" matInput formControlName="dealershipId" maxlength="5" />
                                <mat-error>Route One Dealership Required</mat-error>
                            </mat-form-field>
                            <div mat-dialog-actions>
                                <button mat-raised-button color="primary" [disabled]="isLoading">
                                    Update
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
        </div>
    </div>
</div>
